define('app/views/form',['require','./baseview','./modal','../models/modal'],function(require){

  var BaseView = require('./baseview');
  var Modal = require('./modal');
  var ModalModel = require('../models/modal');

  return BaseView.extend({

    view: 'form',

    step: 0,
    lastStep: 0,
    additionalData: {},
    submitting: false,

    defaults: {
      ajax: true,
      modal: true,
      success: {
        title: 'Thank You!',
        message: 'Your submission has been received.'
      },
      failure: {
        title: 'Sorry!',
        message: 'There was an error with your submission, please try again shortly.'
      },
      parsley: {
        excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden',
        classHandler: function(ParsleyField){
          var label = ParsleyField.$element.closest('label');
          return label.length ? label : ParsleyField.$element;
        }
      }
    },

    events: {
      'click .prefill': 'onClickPrefill',
      'click .previous': 'onClickPrevious',
      'click .next': 'onClickNext',
      'keypress input': 'onKeypressInput'
    },

    initialize: function(options){
      BaseView.prototype.initialize.call(this, options);

      _.bindAll(this,
        'onClickPrefill',
        'onClickPrevious',
        'onClickNext',
        'onKeypressInput',
        'onSubmit',
        'onAJAXSuccess',
        'onAJAXFailure'
      );

      this.lastStep = ($('.step:last').data('step') || 0);

      this.$el.submit(this.onSubmit);

      if(this.options.parsley) {
        this.$el.parsley(this.options.parsley);
      }

      $('[data-mask]', this.$el).each(function(){
        $(this).mask($(this).data().mask);
      });

      $('[data-numeric]', this.$el).each(function(){
        $(this).keypress(function(e){
          var charCode = (e.which) ? e.which : e.keyCode
          return !(charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57));
        });
      });

      $('input,textarea', this.$el).each(function(){
        $(this).placeholder();
      });

      if(!window.isMobile.any) {
        $('select', this.$el).each(function () {
          $(this).select2();
        });
      }

      $('.datepicker', this.$el).each(function(){
        $(this).datepicker({
          minDate: 0
        })
      });

      if(this.options.modal){
        this.modal = new Modal({ model: new ModalModel() });
      }
    },

    serialize: function(){
      return _.extend({}, this.$el.serializeJSON(), this.additionalData);
    },

    getParsley: function(){
      return this.$el.data().Parsley;
    },

    setSubmitting: function(submitting){
      this.submitting = submitting;
      this.$el.toggleClass('submitting', submitting);
    },

    getSubmitting: function(){
      return this.submitting;
    },

    validateForm: function(){
      return true;
    },

    validateStep: function(step){
      var isParsleyValid = this.getParsley() ? this.getParsley().validate('step-' + step) : true;
      var fn = this['validateStep' + step];
      var isStepValid = fn ? fn.call(this) : true;

      return (isParsleyValid && isStepValid);
    },

    updateStep: function(){
      this.$el.removeClassPrefix('step-');
      this.$el.addClass('step-' + this.step);
    },

    onClickPrefill: function(e){
      this.$el.prefill($(e.target).data('set'));
    },

    onClickPrevious: function(e){
      this.step = Math.max((this.step - 1), 0);
      this.updateStep();
    },

    onClickNext: function(e){
      if(this.validateStep(this.step)){
        this.step = Math.min(this.step + 1, this.lastStep);
        this.updateStep();
      };
    },

    onClickSubmit: function(e){
      this.$el.submit();
    },

    onKeypressInput: function(e){
      if(e.keyCode == 13) this.$el.submit();
    },

    beforeSubmit: function(){
    },

    afterSubmit: function(){
    },

    onSubmit: function(e){
      var isParsleyValid = (this.getParsley() && this.getParsley().validate());
      var isFormValid = this.validateForm();

      if(this.getSubmitting() || !isParsleyValid || !isFormValid) {
        return false;
      }

      if(this.options.ajax){
        this.setSubmitting(true);

        var action = (this.$el.data('action') || this.$el.attr('action'));
        var method = (this.$el.data('method') || this.$el.attr('method') || 'POST');
        var data = this.serialize();

        $.ajax({
          url: action,
          type: method,
          dataType: 'json',
          data: data
        }).done(this.onAJAXSuccess).fail(this.onAJAXFailure);

        e.preventDefault();
        return false;
      }
    },

    onAJAXSuccess: function(response){
      //rest form fields
      this.$el.get(0).reset();
      $('input,select,textarea', this.$el).trigger('change');

      //do GA/pixel tracking
      this.track(response);

      //toggle form submitting to false
      this.setSubmitting(false);

      //show the response modal
      if(this.modal){
        var title = (response.TITLE || this.options.success.title);
        var message = (response.MESSAGE || this.options.success.message);
        this.modal.update(title, message).show();
      }
    },

    onAJAXFailure: function(jqXHR, textStatus, errorThrown){
      //toggle form submitting to false
      this.setSubmitting(false);

      //show the response modal
      if(this.modal){
        var title = this.options.failure.title;
        var message = (errorThrown || this.options.failure.message);
        this.modal.update(title, message).show();
      }
    },

    track: function(response){
      _.each((response.TRACKING || []), function(track){
        if(track.GA){
          //GA tracking
          if(ga){
            ga('send', 'event', track.GA_CATEGORY, track.GA_ACTION, track.GA_LABEL, track.GA_VALUE);
          } else {
            console.log('Google Analytics not initialized');
          }
        } else {
          //pixel tracking
          $('#tracking').append(track.PIXEL);
        }
      });
    }

  });

  return Form;

});
